import { useQuery } from '@tanstack/react-query';

import Axios from 'axios';

import {
    coercePlaylistArray,
    normalizeFastPackageBooks,
} from '@components/ContactDetails/ModelDetails/CommonComponents/ModelDetailsBooks/modelDetailsBooks.utils';

/**
 * Endpoint di anteprima per variante. Una variante mappata a null non apre l'anteprima e
 * resta in caricamento: e' la via d'uscita se se ne aggiunge una prima del suo endpoint.
 */
const PREVIEW_ENDPOINTS = {
    fastPackage: (modelId) => `/models/getFastPackages/${modelId}`,
    compCards: (modelId) => `/models/getCompCards/${modelId}`,
    favourites: (modelId) => `/models/getFavourites/${modelId}`,
};

export const hasBooksPreview = (variant) => Boolean(PREVIEW_ENDPOINTS[variant]);

const fetchBooksPreview = async (variant, modelId) => {
    const response = await Axios.get(PREVIEW_ENDPOINTS[variant](modelId));
    const books = coercePlaylistArray(response) ?? [];
    // Il fast package ha un ordine manuale: normalizeFastPackageBooks lo applica.
    return variant === 'fastPackage' ? normalizeFastPackageBooks(books, { alreadyFastFiltered: true }) : books;
};

/**
 * I book che la variante aggiungerebbe al package, per mostrarli in anteprima.
 * La cache tiene il risultato: al secondo hover sulla stessa modella non si richiama il
 * server, ed e' il motivo per cui chi apre l'anteprima deve imporre una permanenza minima
 * prima di espanderla, o la crescita non si vedrebbe.
 */
export const useModelBooksPreview = (variant, modelId, enabled) => {
    const supported = hasBooksPreview(variant);
    const query = useQuery({
        queryKey: ['modelBooksPreview', variant, Number(modelId)],
        queryFn: () => fetchBooksPreview(variant, modelId),
        enabled: Boolean(enabled) && supported && modelId != null,
        staleTime: 60000,
        cacheTime: 300000,
        retry: false,
    });

    if (!supported) {
        return { books: [], isLoading: true, isError: false };
    }

    return {
        books: query.data ?? [],
        isLoading: query.isLoading,
        isError: query.isError,
    };
};
